module.exports = __webpack_public_path__ + "assets/img/activity-head-bottom-back.4a8e8e20.png";